import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { TopDestinationItem } from './TopDestinationItem';
import { getTopDestinations } from '../../redux/topDestinations/actions';
import { getTopDestinationsSelector } from '../../redux/topDestinations/selectors';
import { LocationProp } from '../../models/Location';

export class TopDestinationsDesktop extends PureComponent {
    componentDidMount() {
        const { getTopDestinations } = this.props;
        getTopDestinations();
    }

    render() {
        const { show, onClickItem, options, topDestinations } = this.props;
        const topDestinationsToRender = topDestinations.slice(0, options.sizeList);
        return (
            <React.Fragment>
                { show && topDestinationsToRender.map((item, i) => (

                    <TopDestinationItem
                        key={item.id}
                        index={i}
                        item={item}
                        onClickItem={onClickItem}
                    />
                ))}
            </React.Fragment>
        );
    }
}

TopDestinationsDesktop.propTypes = {
    getTopDestinations: PropTypes.func.isRequired,
    options: PropTypes.object,
    onClickItem: PropTypes.func.isRequired,
    topDestinations: PropTypes.arrayOf(LocationProp),
    show: PropTypes.bool,
};

TopDestinationsDesktop.defaultProps = {
    options: {
        sizeList: 3,
    },
    show: true,
    topDestinations: [],
};

const mapStateToPropsSelector = createStructuredSelector({
    topDestinations: getTopDestinationsSelector,
});

const ConnectedTopDestinations = connect(mapStateToPropsSelector, {
    getTopDestinations,
})(TopDestinationsDesktop);

ConnectedTopDestinations.propTypes = {
    id: PropTypes.number.isRequired,
};

export { ConnectedTopDestinations };
